import { SeoTextBlock } from "@faire/deprecated-retailer-visitor-shared/features/Marketplace/components/SeoTextBlock";
import { PaddedContainer } from "@faire/deprecated-retailer-visitor-shared/features/Marketplace/style";
import { useLoggedOutSuppliersPageTextBlockContent } from "@faire/deprecated-retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/DataFetching/LoggedOutSuppliersPageMetaTags/useLoggedOutSuppliersPageTextBlockContent";
import { Spacer } from "@faire/web/slate/spacing";
import React from "react";

export const MaybeLoggedOutSuppliersPageSEOTextBlockContent = () => {
  const { textBlockHeader, textBlock } =
    useLoggedOutSuppliersPageTextBlockContent();

  if (!textBlockHeader && !textBlock) {
    return null;
  }

  return (
    <PaddedContainer>
      <Spacer height="6x" />
      <SeoTextBlock header={textBlockHeader} content={textBlock} />
      <Spacer height="6x" />
    </PaddedContainer>
  );
};
